module.exports = __webpack_public_path__ + "static/img/nine2.08b71223.jpg";